import React from 'react';

interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'danger';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  onClick, 
  disabled = false,
  className = '',
  style
}) => {
  const baseStyles = 'font-semibold rounded-lg transition-all duration-150 flex items-center justify-center border-2 border-transparent active:scale-95 select-none';
  
  const variants = {
    primary: 'bg-primary active:bg-primary-active text-white border-primary active:border-primary-active shadow-md active:shadow-lg',
    secondary: 'bg-secondary active:bg-secondary-active text-white border-secondary active:border-secondary-active shadow-md active:shadow-lg',
    outline: 'border-gray-300 active:border-gray-500 text-gray-700 bg-white active:bg-gray-100 shadow-sm active:shadow-md',
    danger: 'bg-[#E32B26] active:bg-[#c72421] text-white border-[#E32B26] active:border-[#c72421] shadow-md active:shadow-lg'
  } as const;

  const sizeStyles = {
    sm: 'min-h-touch-sm px-6 text-kiosk-base font-medium',      // 48px minimum height
    md: 'min-h-touch-md px-8 text-kiosk-lg font-semibold',     // 56px minimum height  
    lg: 'min-h-touch-lg px-10 text-kiosk-xl font-semibold',    // 64px minimum height
    xl: 'min-h-touch-xl px-12 text-kiosk-2xl font-bold'        // 72px minimum height
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizeStyles[size]} ${disabled ? 'opacity-50 cursor-not-allowed active:scale-100' : 'cursor-pointer'} ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      disabled={disabled}
      style={style}
    >
      {children}
    </button>
  );
};

export default Button; 